import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ApplicationTypeForm from './ApplicationTypeForm';

const ApplicationTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ApplicationTypeCreate = (props: any) => {
  return (
    <Create actions={<ApplicationTypeActions {...props} />} {...props}>
      <ApplicationTypeForm />
    </Create>
  );
};

export default ApplicationTypeCreate;
